
import { getFirestore, collection, addDoc, getDocs, query, where, deleteDoc, doc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFirebaseApp } from './firebaseConfig';

export const deleteToolFromFirestore = async (toolId) => {
  const db = getFirestore(getFirebaseApp());
  await deleteDoc(doc(db, 'tools', toolId));
};

const db = getFirestore(getFirebaseApp());

export const addToolToFirestore = async (tool) => {
  const user = getAuth().currentUser;
  if (!user) throw new Error('ログインが必要です');
  const docRef = await addDoc(collection(db, 'tools'), {
    ...tool,
    uid: user.uid,
    createdAt: new Date()
  });
  return docRef.id;
};

export const getToolsFromFirestore = async (uid) => {
  const q = query(collection(db, 'tools'), where('uid', '==', uid));
  const snap = await getDocs(q);
  return snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};
